import * as React from 'react';
import {Box, Button, HStack, Link, Stack, Text} from '@chakra-ui/react';
import {LinkedinSvg, LinkSvg, MediumIconSvg, TwitterSvg} from '../../../../assets';
import {htmlDecode} from "../../../../utils/htmlDecode";

const Content = React.forwardRef(({top, data}, ref) => {
    const clacedTop = top ? `${top}px` : '0';

    /*
        {data?.acf?.focus_sectors?.length > 0 ? (
                                <>
                                    {data?.acf?.focus_sectors?.map((item, index) => (
                                        <>
                                            <Link
                                                href={`/companies?sector=${encodeURI(item.slug.split(' ').join('+')).replace("&", "%26")}`}>{htmlDecode(item.name)}</Link>
                                            {index < data?.acf?.focus_sectors?.length - 1 ? ", " : ""}
                                        </>
                                    ))}
                                </>
                            ) : data?.acf?.focus}
    */

    return (
        <Box
            ref={ref}
            display={'flex'}
            flexDirection={'column'}
            // justifyContent={'space-between'}
            textAlign={'left'}
            w={"500px"}
            maxW="100%"
            h={{base: 'auto'}}
            minH={{base: 'auto'}}
            maxH={{base: 'auto'}}
            position={{base: 'relative'}}
            top={{base: 'none', lg: clacedTop}}
            bottom={{base: 'none', lg: '0'}}
            left={'0'}
            maxWidth={{base: '100%', lg: '50%', xl: 'auto'}}
        >
            <Box
                display={{lg: 'block', base: 'none'}}
                mb={'50px'}
                mt={{base: '46px', lg: '79px'}}
            >
                <Text mb={'20px'} as={'h1'} fontSize={'md'} lineHeight={'5'}>
                    {data?.acf?.job_title}
                </Text>
                <Text
                    as={'h2'}
                    ml={'-8px'}
                    fontSize={'5rem'}
                    lineHeight={'5rem'}
                    letterSpacing={'-2px'}
                >
                    {data?.acf?.first_name} {data?.acf?.last_name}
                </Text>
            </Box>
            <Box display={'block'}>
                <Box mb={{base: '20px', lg: '20px'}}>
                    <Text as={'span'} textColor={'brand.700'} fontSize={'xs'} lineHeight={'10.4px'}>
                        Location
                    </Text>
                    <Text mb={'20px'} as={'p'} fontSize={'md'} lineHeight={'6'}>
                        {data?.acf?.office}
                    </Text>
                </Box>
                {data?.teams.length > 0 &&
                    <Box mb={{base: '20px', lg: '20x'}}>
                        <Text as={'span'} textColor={'brand.700'} fontSize={'xs'} lineHeight={'10.4px'}>
                            Team{data?.teams.length > 1 ? 's' : ''}
                        </Text>
                        <Text
                            mb={'20px'}
                            as={'p'}
                            fontSize={'md'}
                            lineHeight={'6'}
                        >
                            {data?.teams.map((item) => item.team).join(', ')}
                        </Text>
                    </Box>
                }
                {(data?.acf?.focus || (data?.acf?.focus_sectors && data?.acf?.focus_sectors.length > 0)) &&
                    <Box>
                        <Text as={'span'} textColor={'brand.700'} fontSize={'xs'} lineHeight={'10.4px'}>
                            Focus Areas
                        </Text>
                        <Text
                            mb={{base: '40px', lg: '40px'}}
                            as={'p'}
                            fontSize={'md'}
                            lineHeight={'6'}
                            dangerouslySetInnerHTML={{__html: data?.acf?.focus}}
                        />
                    </Box>
                }
                <Stack
                    spacing={2}
                    flexDirection={{base: 'column', lg: 'row'}}
                    flexWrap={'wrap'}
                    alignItems={{base: 'start', lg: 'center'}}
                    display={'flex'}
                >
                    {data?.acf?.email &&
                        <a href={`mailto:${data?.acf?.email}`} target="_blank" rel="noopener noreferrer">
                            <Button
                                fontSize={'12px'}
                                lineHeight={'12px'}
                                maxW={'200px'}
                                size={'lg'}
                                isActive
                                mr={{base: '0', lg: '20px'}}
                                mb={{base: '40px', lg: '0px'}}
                            >
                                Get in touch with {data?.acf?.first_name}
                            </Button>
                        </a>
                    }
                    <HStack
                        w={{base: 'full', lg: 'auto'}}
                        spacing={{base: '13px', lg: '0'}}
                        m={'0 !important'}
                    >
                        {data?.acf?.twitter &&
                            <a href={`https://twitter.com/${data?.acf?.twitter}`} target="_blank"
                               rel="noopener noreferrer">
                                <Button
                                    size={'xs'}
                                    variant={'solid'}
                                    bgColor={'transparent'}
                                    iconSpacing={0}
                                    borderRadius={'full'}
                                >
                                    <TwitterSvg/>
                                </Button>
                            </a>
                        }
                        {data?.acf?.linkedin &&
                            <a href={`${data?.acf?.linkedin}`} target="_blank" rel="noopener noreferrer">
                                <Button
                                    size={'xs'}
                                    variant={'solid'}
                                    bgColor={'transparent'}
                                    iconSpacing={0}
                                    borderRadius={'full'}
                                >
                                    <LinkedinSvg/>
                                </Button>
                            </a>
                        }
                        {data?.acf?.medium_url &&
                            <a href={`${data?.acf?.medium_url}`} target="_blank" rel="noopener noreferrer">
                                <Button
                                    size={'xs'}
                                    variant={'solid'}
                                    bgColor={'transparent'}
                                    iconSpacing={0}
                                    borderRadius={'full'}
                                >
                                    <MediumIconSvg/>
                                </Button>
                            </a>
                        }
                        {data?.acf?.blog_url &&
                            <a href={`${data?.acf?.blog_url}`} target="_blank" rel="noopener noreferrer">
                                <Button
                                    size={'xs'}
                                    variant={'solid'}
                                    bgColor={'transparent'}
                                    iconSpacing={0}
                                    borderRadius={'full'}
                                >
                                    <LinkSvg/>
                                </Button>
                            </a>
                        }
                    </HStack>
                </Stack>
            </Box>
        </Box>
    );
});
export default Content;
